import React from "react";
import "./OurOfferings.css";

const OurOfferings = () => {
  const offerings = [
    {
      img: "/Images/food.jpeg.jpg",
      title: "Food",
      desc: "Enjoy fresh and delicious meals curated to energize your journey.",
    },
    {
      img: "/Images/travel.jpg",
      title: "Travel",
      desc: "Comfortable and safe travel arrangements for a smooth experience.",
    },
    {
      img: "/Images/accommodation.jpg",
      title: "Accommodation",
      desc: "Stay in well-maintained, clean, and relaxing accommodation spaces.",
    },
  ];

  return (
    <section className="offerings59-section">
      <div className="offerings59-header">
        <img src="/Images/ballimg.png" alt="Ball" className="offerings59-ball-icon" />
        <p className="offerings59-subtext">YOUR NEEDS, OUR SERVICE</p>
        <h2 className="offerings59-title">OUR OFFERINGS</h2>
      </div>

      <div className="offerings59-container">
        {offerings.map((item, index) => (
          <div key={index} className="offerings59-card no-click">
            <div className="offerings59-image-box">
              <img src={item.img} alt={item.title} />
            </div>

            <button className="offerings59-title-btn" disabled>
              {item.title}
            </button>

            <p className="offerings59-desc">{item.desc}</p>

            <button className="offerings59-click-btn" disabled>
              →
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OurOfferings;
